import React from 'react'
import {
  Link, Route, Routes,
  type PathRouteProps,
  type IndexRouteProps
} from 'react-router-dom'
import { LoginCallback, Security } from '@okta/okta-react'
import { MSLayoutContentRow, MSLayoutTitleRow } from '@choreograph/layout'
import { oktaAuthHandler } from '@choreograph/authjs'

import { type IWppPermissionedRoute, WppPermissionedRoute } from './PermissionedRouteComponent'

export type IWppPermissionedRouteProps = IWppPermissionedRoute & (PathRouteProps | IndexRouteProps)
export interface IWppRoutesComponent {
  routes: IWppPermissionedRouteProps[]
}

export const CallbackRouteComponent = LoginCallback
export const ForbiddenRouteComponent = () => (
  <div>
    <h3>Not Authorised!</h3>
    <p>Please contact an administrator.</p>
  </div>
)
export const NotFoundRouteComponent: React.FC = () => (
  <>
    <MSLayoutTitleRow headingSize={2}>404 - Not Found</MSLayoutTitleRow>
    <MSLayoutContentRow>
      <Link to='/'>Go back home</Link>
    </MSLayoutContentRow>
  </>
)

export const LogoutRouteComponent: React.FC = () => (
  <MSLayoutContentRow>
    <h3>You have logged out!</h3>
    <Link to='/'>Go back home</Link>
  </MSLayoutContentRow>
)

export const WppRoutesComponent = ({ routes }: IWppRoutesComponent) => (
  <Security
    oktaAuth={oktaAuthHandler.getAuth()}
    // eslint-disable-next-line @typescript-eslint/unbound-method
    restoreOriginalUri={oktaAuthHandler.restoreOriginalUri}
  >
    <Routes>
      {/* Okta-only routes */}
      <Route path={oktaAuthHandler.paths.callback} element={<CallbackRouteComponent />} />
      <Route path={oktaAuthHandler.paths.forbidden} element={<ForbiddenRouteComponent />} />
      <Route path={oktaAuthHandler.paths.logout} element={<LogoutRouteComponent />} />

      {routes.map(renderPermissionedRoutes)}

      {/* fallback: Not Found */}
      <Route path='*' element={<NotFoundRouteComponent />} />
    </Routes>
  </Security>
)

export default WppRoutesComponent

const renderPermissionedRoutes = ({ permissions, element, redirectPath, fallback, subscribe, ...props }: IWppPermissionedRouteProps) => (
  <Route
    {...props}
    key={props.path}
    element={(
      <WppPermissionedRoute
        permissions={permissions}
        element={element}
        redirectPath={redirectPath}
        subscribe={subscribe}
        fallback={fallback}
      />
    )} />
)
